<template>
  <div class="detai-container main-w">
    <!-- 面包屑 -->
    <Crumbs>
      <template v-slot:current> 正文 </template>
      <template v-slot:date>
        <div class="date">{{ detailInfo.inputtm }}</div>
        <div class="number">浏览次数: {{ detailInfo.visitnum }}次</div>
      </template>
    </Crumbs>
    <!-- 详细页内容 -->
    <div ref="detail" class="content" v-html="detailInfo.content"></div>
  </div>
</template>

<script>
import Crumbs from '@/components/Crumbs'
export default {
  components: {
    Crumbs
  },
  data() {
    return {
      detailInfo: {},
      certAbout: {}
    }
  },
  methods: {
    // 文章详情
    async getDetailInfo() {
      const { id } = this.$route.params
      const { data } = await this.service1('news/newsShow', { id }, 'post')
      
        this.detailInfo = data
      this.$nextTick(() => {
        this.$refs.detail.style.textIndent = "2em"
        this.$refs.detail.style.fontSize = "18px"
      })
      
      
    },
    async getAbout() {
      const {data} = await this.service1('About/aboutShow', 'post')
      this.certAbout = data
    }


  },
  created() {
    this.getDetailInfo()
  },
  mounted() {

  }
}
</script>
<style lang="less" scoped>
.detai-container {
  box-sizing: border-box;
  background-color: #fff;
  padding: 10px 23px;
  .content {
    padding: 0 80px;
  }
}
</style>